import { render, staticRenderFns } from "./addProductPriceRule.vue?vue&type=template&id=28a03c9a"
import script from "./addProductPriceRule.vue?vue&type=script&lang=js"
export * from "./addProductPriceRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports